import { queryClient } from 'App';

import { invalidateHealthSummaryForPatient } from 'lib/helpers/healthSummaryCache';

const PATIENT_RECORD_KEYS = [
  'pastMedicalHistory',
  'socialHistory',
  'surgicalHistory',
  'familyHistory',
  'patientAllergy',
  'vaccines'
];

export default async (data) => {
  const { patient_id } = data;

  invalidateHealthSummaryForPatient({ queryClient, patientId: patient_id });
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) =>
      PATIENT_RECORD_KEYS.includes(queryKey?.[0]) &&
      queryKey.some((key) => String(key) === String(patient_id)),
    refetchType: 'none'
  });
};
